import Dropdown from "@shared/v2/Dropdown";
import Avatar from "@shared/v2/Avatar";

const AvatarControl = ({ componentProps, data, children }) => {
  const src = data?.image_url;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return (
    <Dropdown.Control {...componentProps} preserveStyle>
      <Avatar src={src} />
      {children}
    </Dropdown.Control>
  );
};
export default AvatarControl;
